import React, { useEffect } from 'react'
import clsx from 'clsx'
import shallow from 'zustand/shallow'
import { useCurtain } from '../app/hooks'
import { useStaticData } from '../../data'
import { CurtainFilters } from './CurtainFilters'
import { CurtainLoader } from './CurtainLoader'
import { CurtainSkip } from './CurtainSkip'

export const Curtain = () => {
  const { showCurtain, setShowCurtain, showCurtainFilters, setShowCurtainFilters } = useCurtain()
  const [loaded, loading, isLoading] = useStaticData(
    state => [state.loaded, state.loading, state.isLoading],
    shallow
  )

  const removeStatic = () => {
    const staticElem = document.querySelector('.section--static')
    if (staticElem) staticElem.remove()
  }

  const onBackClick = () => {
    window.history.go(-1)
  }

  useEffect(() => {
    removeStatic()
    const hasUrlParams = window.location.hash.length > 2
    const isDisabledInLocalStorage = Boolean(localStorage.getItem('seda-trends-disable-curtain'))
    const dontShowFilters = hasUrlParams || isDisabledInLocalStorage
    // console.log(hasUrlParams, isDisabledInLocalStorage)
    if(!dontShowFilters) setShowCurtainFilters(true)
  }, [])

  useEffect(() => {
    if(
      !isLoading &&
      loaded.length > 0 &&
      !showCurtainFilters
    ) {
      setShowCurtain(false)
    }
  }, [loaded, loading, isLoading, showCurtainFilters, setShowCurtain])

  return (
    <div className={clsx("section", "section--curtain", !showCurtain && "section--hidden")}>
      <div className="section__column">
        <div className="section__inner">
          <div className="section__main">
            <div className="section__header">
              <div className="section__seda">
                <svg className="section__seda_logo">
                  <use xlinkHref="#seda-logo"></use>
                </svg>
              </div>
              <h1 className="section__title">
                <span role="text">The Educational Opportunity Trends Project</span>
              </h1>
              <p className="section__description">
                We examine trends in educational opportunity from 2009-2025 across the country, with a focus on achievement and learning from 2022-2025.
              </p>
            </div>

            <div className={clsx("section__body", isLoading ? "section__body--loading" : null)}>
              {showCurtainFilters ?
                <CurtainFilters
                  loading={isLoading}
                />
              : <CurtainLoader />}
              <div className="section__unsupported">
                <p>
                  The browser you are using does not support the
                  features required to use this tool. Please switch to
                  a modern browser (MS Edge, Safari, Firefox, Google
                  Chrome, etc.) and ensure WebGL is enabled.
                </p>
                <button className="button" onClick={onBackClick}>
                  Go Back
                </button>
              </div>
            </div>
          </div>
          {showCurtainFilters ?
            <CurtainSkip />
          : null}
        </div>
      </div>
    </div>
  )
}